import moment from 'moment';

// Work experience, education and qualifications are saved as whole arrays.
// These helpers edit one entry without dropping or duplicating the others.

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const API_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/** Newest first, from `ahead` years after this one back to 1950. */
export const yearOptions = (ahead = 0, now = new Date()) => {
  const years = [];
  for (let year = now.getFullYear() + ahead; year >= 1950; year--) {
    years.push(year);
  }
  return years;
};

/** { month: 0-11, year } from an API date, with '' for anything unset. */
export const toMonthYear = (date) => {
  const parsed = date ? moment(date) : null;
  if (!parsed || !parsed.isValid()) {
    return { month: '', year: '' };
  }
  return { month: parsed.month(), year: parsed.year() };
};

export const toYear = (date) => toMonthYear(date).year;

/**
 * An API date for the month and year. Keeps the original value when it is
 * already in that month, so opening and saving an entry changes nothing.
 */
export const fromMonthYear = ({ month, year }, original) => {
  if (month === '' || year === '') {
    return '';
  }
  const current = toMonthYear(original);
  if (current.month === month && current.year === year) {
    return original;
  }
  return moment({ year, month, day: 1 }).format(API_FORMAT);
};

export const fromYear = (year, original) => {
  if (year === '') {
    return '';
  }
  if (toYear(original) === year) {
    return original;
  }
  return moment({ year, month: 0, day: 1 }).format(API_FORMAT);
};

/** Is the first month/year later than the second? */
export const isAfter = (a, b) =>
  a.year !== '' &&
  b.year !== '' &&
  (a.year > b.year ||
    (a.year === b.year &&
      a.month !== '' &&
      b.month !== '' &&
      a.month > b.month));

export const isSameEntry = (a, b) =>
  !!a && !!b && (a === b || (a.id != null && a.id === b.id));

/** Replaces `original` with `entry`, or appends `entry` when there is none. */
export const upsertEntry = (entries, original, entry) => {
  if (!original) {
    return [...entries, entry];
  }
  let found = false;
  const next = entries.map((item) => {
    if (!found && isSameEntry(item, original)) {
      found = true;
      return entry;
    }
    return item;
  });
  return found ? next : [...entries, entry];
};

export const withoutEntries = (entries, removed) =>
  entries.filter((item) => !removed.some((gone) => isSameEntry(item, gone)));
